import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import { cloneDeep, isEmpty } from "lodash";

import type { IConfigurationGroupMonitoring, IResponseWithLoading, ISite } from "App/Modules/Models";
import { NotificationType } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { PatchDelta } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class ConfigurationGroupMonitoringEditComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository"];

    public original: IConfigurationGroupMonitoring;

    public modified: IConfigurationGroupMonitoring;

    public site: IResponseWithLoading<ISite>;

    public editResponse: IResponseWithLoading<IConfigurationGroupMonitoring>;

    public deleteResponse: IResponseWithLoading<void>;

    public resolve: IFormContainerResolve<IConfigurationGroupMonitoring, void>;

    public notificationTypes: any[] = [
        { type: NotificationType.DailyAlarmReport },
        { type: NotificationType.ScheduleExceptionAdded },
    ];

    constructor(private readonly $scope: IScope, private readonly sitesRepository: ISitesRepository) {}

    public $onInit() {
        this.original = this.resolve.formData;

        this.modified = cloneDeep(this.original);

        extendWithLoadingAndFail(this.sitesRepository.getSite(this.original.siteId))
            .pipe(
                finalize(() => {
                    this.$scope.$applyAsync();
                }),
            )
            .subscribe(
                (result) => {
                    this.site = result;
                },
                (result) => {
                    this.site = result;
                },
            );
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public save() {
        const delta = PatchDelta.difference(this.original, this.modified);

        if (!isEmpty(delta)) {
            extendWithLoadingAndFail(
                this.sitesRepository.patchConfigurationGroupReporting(this.original.siteId, this.original.id, delta),
            )
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (editResponse: IResponseWithLoading<IConfigurationGroupMonitoring>) => {
                        this.editResponse = editResponse;

                        if (!editResponse.isLoading && editResponse.data) {
                            this.resolve.options.onOk(editResponse.data);
                        }
                    },
                    (errorResponse) => {
                        this.editResponse = errorResponse;
                    },
                );
        } else {
            this.resolve.options.onCancel();
        }
    }

    public delete() {
        extendWithLoadingAndFail(this.sitesRepository.deleteConfigurationGroup(this.original.siteId, this.original.id))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (deleteResponse: IResponseWithLoading<void>) => {
                    this.deleteResponse = deleteResponse;

                    if (!deleteResponse.isLoading) {
                        this.resolve.options.onOk(null);
                    }
                },
                (error) => {
                    this.deleteResponse = error;
                },
            );
    }
}
